import Vue from 'vue'
import VueRouter from 'vue-router'




import Login from './components/Login';
import Register from './components/user/Register'
// import PhotoGallery from "./components/user/PhotoGallery";
// import Announcement from './components/user/Announcement';
import Home from './components/user/Home';
import Details from "./components/user/Details";
import EditDetails from "./components/user/EditDetails";
import AnnouncementDetails from "./components/user/AnnouncementDetails";
import AlbumView from "./components/user/AlbumView";
import UserSearch from "./components/user/Users";

import AdminDashboard from "./components/admin/AdminDashboard";
import AdminAnnouncement from './components/admin/Announcement';
import AdminGallery from './components/admin/PhotoGallery';
import AddEditAnnouncement from "./components/admin/AddEditAnnouncement";
import AddEditAlbum from "./components/admin/AddEditAlbum";
import Users from "./components/admin/Users";
import Admins from "./components/admin/Admins";
import UserDetails from "./components/admin/UserDetails";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',
    // base: '/gciosa/public',
    // base: process.env.BASE_URL,
    routes: [
        {
            path: '/home',
            name: 'home',
            component: Home
        },

        {
            path: '/',
            // redirect: '/',
            name: 'login',
            component: Login
        },

        {
            path: '/register',
            name: 'register',
            component: Register
        },
        // {
        //     path: '/gallery',
        //     name: 'gallery',
        //     component: PhotoGallery
        // },
        // {
        //     path: '/announce',
        //     name: 'announce',
        //     component: Announcement
        // },
        {
            path: '/acct',
            name: 'acct',
            component: Details
        },
        {
            path: '/edit_acct',
            name: 'edit_acct',
            component: EditDetails
        },
        {
            path: '/announce_details/:id',
            name: 'announce_detail',
            component: AnnouncementDetails
        },
        {
            path: '/gallery/:id',
            name: 'gallery',
            component: AlbumView
        },

        {
            path: '/users',
            name: 'users',
            component: UserSearch
        },

        {
            path: '/dashboard',
            name: 'dashboard',
            component: AdminDashboard
        },
        {
            path: '/admin/announcement',
            name: 'admin_announcement',
            component: AdminAnnouncement
        },
        {
            path: '/admin/gallery',
            name: 'admin_gallery',
            component: AdminGallery
        },
        {
            path: '/admin/add_edit_announcement/:id',
            name: 'admin_add_announcement',
            props: {add: false},
            component: AddEditAnnouncement
        },
        {
            path: '/admin/add_edit_announcement',
            name: 'admin_edit_announcement',
            props: {add: true},
            component: AddEditAnnouncement
        },
        {
            path: '/admin/add_edit_album/:id',
            name: 'admin_add_album',
            props: {add: false},
            component: AddEditAlbum
        },
        {
            path: '/admin/add_edit_album',
            name: 'admin_edit_album',
            props: {add: true},
            component: AddEditAlbum
        },
        {
            path: '/admin/users',
            name: 'admin_users',
            component: Users
        },
        {
            path: '/admin/admins',
            name: 'aadmin_dmins',
            component: Admins
        },
        {
            path: '/users/:id',
            name: 'user_details',
            component: UserDetails
        }

    ],
});

export default router;
